import { gql } from '@apollo/client'

export const Query = gql`
  query AssetTypes($companyId: ID!, $filters: AssetTypeFilters, $order: AssetTypeOrder, $after: String, $before: String, $first: Int, $last: Int) {
    assetTypes(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        image { id url }
        images {
          id
          url
        }
        categories {
          id
          name
          color
        }
        availableToEvents
        displayOnWebsite
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
